module.exports = __webpack_public_path__ + "static/media/vesselstop.1942effc.svg";